import type { SignUpProvisioningView } from "../../../domain/v2";
import { ExistingElationAccountPanel } from "../ExistingElationAccountPanel";
import { SignUpStepFooter } from "../SignUpStepFooter";
import { SignUpStepLayout } from "../SignUpStepLayout";
import { TrustStep } from "../TrustStep";
import { WaitingForAccountPanel } from "../WaitingForAccountPanel";

export interface ProvisioningGateStepProps {
  provisioningView: SignUpProvisioningView;
  ctaLabel?: string;
  onBack?: () => void;
  onContinue?: () => void;
}

export function ProvisioningGateStep({
  provisioningView,
  ctaLabel = "Verify email",
  onBack,
  onContinue,
}: ProvisioningGateStepProps) {
  const isExistingElationAccount =
    provisioningView.state === "failed" && "signInHref" in provisioningView;
  const isPending = provisioningView.state === "pending";
  const canEnter = provisioningView.state === "succeeded";

  if (isExistingElationAccount) {
    return (
      <SignUpStepLayout
        description="An Elation account with this email already exists."
        footer={null}
        stepNumber={4}
        title="Account already exists"
        totalSteps={5}
      >
        <ExistingElationAccountPanel />
      </SignUpStepLayout>
    );
  }

  if (isPending) {
    return (
      <SignUpStepLayout
        description="This usually finishes before you reach this step."
        footer={null}
        stepNumber={4}
        title="Setting up your account"
        totalSteps={5}
      >
        <WaitingForAccountPanel message={provisioningView.message} />
      </SignUpStepLayout>
    );
  }

  return (
    <SignUpStepLayout
      description="Here's what happens to a visit, and what never does."
      footer={
        <SignUpStepFooter
          ctaDisabled={!canEnter}
          ctaLabel={ctaLabel}
          hideSkip
          onBack={onBack}
          onContinue={onContinue}
        />
      }
      stepNumber={4}
      title="Your data, handled carefully"
      totalSteps={5}
    >
      <TrustStep provisioningView={provisioningView} />
    </SignUpStepLayout>
  );
}
